// Copyright 2016 Sorama B.V.

import { CreditsDebetAction } from "datatypes/CreditsMutation";

export abstract class ICreditsService {
    public abstract get currentCreditSaldo(): number;

    public abstract updateCurrentCreditsSaldo(): Promise<number>;

    public abstract creditSaldoMutation(creditDebetAction: CreditsDebetAction): Promise<void>;

    public abstract getDebetActionCosts(): CreditsDebetAction[];
}
